import * as contentRange from "content-range";

export class SaleResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource: ng.resource.IResourceService, { contentApi }) {
        return (headers = {}) =>
            $resource(
                `${contentApi.url}/v1/sales/:id`,
                { id: "@id" },
                {
                    update: {
                        method: "PATCH"
                    },
                    reset: {
                        method: "POST",
                        url: `${contentApi.url}/v1/sales/:id/purge`
                    },
                    setMediaCatalog: {
                        method: "POST",
                        url: `${contentApi.url}/v1/sales/:id/sale_catalog`
                    },
                    deleteMediaCatalog: {
                        method: "DELETE",
                        url: `${contentApi.url}/v1/sales/:id/sale_catalog`
                    },
                    setMediaResults: {
                        method: "POST",
                        url: `${contentApi.url}/v1/sales/:id/sale_results`
                    },
                    deleteMediaResults: {
                        method: "DELETE",
                        url: `${contentApi.url}/v1/sales/:id/sale_results`
                    },
                    setSaleConditions: {
                        method: "POST",
                        url: `${contentApi.url}/v1/sales/:id/sale_conditions`
                    },
                    deleteSaleConditions: {
                        method: "DELETE",
                        url: `${contentApi.url}/v1/sales/:id/sale_conditions`
                    },
                    createItem: {
                        method: "POST",
                        url: `${contentApi.url}/v1/sales/:id/items`,
                        headers
                    },
                    countItems: {
                        method: "HEAD",
                        headers,
                        url: `${contentApi.url}/v1/sales/:id/items`,
                        transformResponse: (data, headersGetter) => {
                            // TODO : check if value is not null
                            const range = contentRange.parse(headersGetter("Content-Range"));
                            const totalFound = range && range.length;
                            return { count: totalFound };
                        }
                    },
                    getItems: {
                        method: "GET",
                        url: `${contentApi.url}/v1/sales/:id/items`,
                        isArray: true,
                        headers,
                        params: {
                            suppressed: "@suppressed"
                        },
                        cancellable: true
                    },
                    publish: {
                        method: "POST",
                        url: `${contentApi.url}/v1/sales/:id/publish`,
                        headers
                    },
                    getPublished: {
                        method: "GET",
                        url: `${contentApi.url}/v1/sales/:id/published`
                    }
                }
            );
    }
}

class SaleTranslationsResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource: ng.resource.IResourceService, { contentApi, gatewayApi }) {
        return (_headers = {}) =>
            $resource(
                `${contentApi.url}/v1/sales/:id`,
                { id: "@id" },
                {
                    getSaleStatus: {
                        method: "GET",
                        url: `${gatewayApi.url}/v1/sales/:id/status`
                    },
                    translate: {
                        method: "PATCH",
                        url: `${contentApi.url}/v1/sales/:id/translations`
                    }
                }
            );
    }
}

angular
    .module("thor.core.sale.resource", [])
    .factory("saleResource", SaleResource)
    .factory("saleTranslationsResource", SaleTranslationsResource);
